import { Directive, signal, WritableSignal } from '@angular/core';
import { FormArray } from '@angular/forms';

import { DialogBase } from 'tiime-material';

import { EmailAddressForm } from '@forms/email-address-form';
import { GiEmailTemplate } from '@gi/models/gi-email-template';
import { EmailFrom } from '@models/email-from';

@Directive()
export abstract class SendMailDialogBase<T> extends DialogBase<T> {
  readonly emailTemplate: WritableSignal<GiEmailTemplate> = signal<GiEmailTemplate>(null);
  readonly fromEmails: WritableSignal<EmailFrom[]> = signal<EmailFrom[]>([]);
  readonly displayTo: WritableSignal<boolean> = signal<boolean>(false);
  readonly displayCc: WritableSignal<boolean> = signal<boolean>(false);
  readonly displayCci: WritableSignal<boolean> = signal<boolean>(false);

  initEmailAddressForm(emails: string[], control: FormArray<EmailAddressForm>): void {
    control.clear({ emitEvent: false });
    emails.forEach(email => {
      const emailAddressForm = new EmailAddressForm();
      emailAddressForm.patchValue({ address: email, canBeDeleted: false });
      control.push(emailAddressForm);
    });
  }

  abstract initForm(): void;
  abstract initEmailForm(template: GiEmailTemplate): void;
}
